export enum AddressPopWindowType {
  suggest = 'suggest',
  error_field = 'error_field',
  failed = 'failed',
  success = 'success'
}

export enum LoginSessionstoragekey {
  login_key = 'login_key'
}
